import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 3,
  border: "1px solid #b2b3b3",
  width: 12,
  height: 12,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "none",
  backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "transparent",
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "transparent",
  "&:before": {
    display: "block",
    width: 12,
    height: 12,
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23114A65'/%3E%3C/svg%3E\")",
    content: '""',
  },
  "input:hover ~ &": {
    backgroundColor: "transparent",
  },
});

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
};

// Inspired by blueprintjs
function BpCheckbox(props) {
  return (
    <Index.Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
}

export default function ReplaceCaption() {
  const { adminDetails } = useSelector((state) => state.AdminReducer);
  const formRef = useRef();
  const [buttonSpinner, setButtonSpinner] = useState(false);
  const [advertisorData, setAdvertisorData] = useState([]);
  const [salesOrderData, setSalesOrderData] = useState([]);
  const [previousBookingData, setPreviousBookingData] = useState([]);
  const [creativesData, setCreativesData] = useState([]);
  const [creativesDataForPayload, setCreativesDataForPayload] = useState([]);
  const [bookingId, setBookingId] = useState("");
  const [subBookingData, setSubBookingData] = useState([]);
  const [creativesByClientData, setCreativesByClientData] = useState([]);
  console.log({ subBookingData });
  console.log({ creativesData });

  const [open, setOpen] = useState(false);
  const [openCalenderReplaceStart, setOpenCalenderReplaceStart] =
    useState(false);
  const [openCalenderReplaceEnd, setOpenCalenderReplaceEnd] = useState(false);

  const initialValues = {
    replace: true,
    discontinue: false,
    client: "",
    campaign: "",
    booking: "",
    subBooking: "",
    creative: "",
    endDate: null,
    replaceCampaign: "",
    replaceStartDate: null,
    replaceEndDate: null,
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  const handleGetAdvertiserList = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_ADVERTISER).then((res) => {
      if (res?.status === 200) {
        setAdvertisorData(
          res?.data?.filter((item) => item?.isActive && !item?.isDraft)
        );
      }
    });
  };
  const handleGetSalesOrder = () => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_ALL_SALES_ORDERS_LIST).then(
      (res) => {
        if (res.status === 200) {
          setSalesOrderData(res?.data);
        }
      }
    );
  };
  const handleGetPreviousBookings = (id) => {
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_PREVIOUS_BOOKINGS_BY_SALES_ORDER_ID + "/" + id
    ).then((res) => {
      if (res.status === 200) {
        setPreviousBookingData(res?.data);
      }
    });
  };
  const handleGetSubBooking = (id) => {
    PagesIndex.apiGetHandler(PagesIndex.Api.GET_SUB_BOOKING_ID + "/" + id).then(
      (res) => {
        if (res.status === 200) {
          setSubBookingData(res?.data);
        }
      }
    );
  };
  const handleGetCreatives = (body) => {
    PagesIndex.apiPostHandler(
      PagesIndex.Api.GET_CREATIVE_FOR_SUB_ORDER_ID,
      body
    ).then((res) => {
      if (res.status === 200) {
        setCreativesData(res?.data);
      } else {
        setCreativesData([]);
      }
    });
  };

  const handleGetCreativesForPayload = (body) => {
    PagesIndex.apiPostHandler(
      PagesIndex.Api.GET_CREATIVE_FOR_SUB_ORDER_ID,
      body
    ).then((res) => {
      if (res.status === 200) {
        setCreativesDataForPayload(res?.data.map((item) => item._id));
      }
    });
  };

  useEffect(() => {
    handleGetCreativesForPayload({
      type: "discontinue",
      id: bookingId,
      booking_id: subBookingData?.[0],
    });
  }, [bookingId, subBookingData]);

  const handleGetCreativesByClient = (id) => {
    PagesIndex.apiGetHandler(
      PagesIndex.Api.GET_CREATIVES_BY_CLIENT + "/" + id
    ).then((res) => {
      if (res.status === 200) {
        setCreativesByClientData(
          res?.data?.getCreative?.filter(
            (data) =>
              data?.isActive &&
              !data?.isDeleted &&
              data?.platformId?._id === "664360b5b539341a1a081253"
          )
        );
      }
    });
  };

  useEffect(() => {
    handleGetAdvertiserList();
    handleGetSalesOrder();
  }, []);

  const handleSubmitForm = (values) => {
    setButtonSpinner(true);
    const urlEncoded = new URLSearchParams();
    if (values?.replace) {
      urlEncoded.append("type", values?.replace && "replace");
    }
    if (values?.discontinue) {
      urlEncoded.append("type", values?.discontinue && "discontinue");
    }
    urlEncoded.append("campaign", values?.campaign);
    urlEncoded.append("bookingId", values?.booking);

    if (values?.subBooking && values?.creative) {
      urlEncoded.append("subBookingId", values?.subBooking);
    }
    if (values?.creative) {
      urlEncoded.append("oldCreative", values?.creative);
    }

    if (values?.discontinue && !values?.creative) {
      urlEncoded?.append("subBookingId", subBookingData?.[0]);
      creativesDataForPayload?.forEach((id) => {
        urlEncoded?.append("oldCreative[]", id);
      });
    }

    urlEncoded.append("creativeId", values?.replaceCampaign);
    urlEncoded.append(
      "start",
      PagesIndex.dayjs(values?.replaceStartDate).format("YYYY-MM-DD")
    );
    urlEncoded.append(
      "end",
      PagesIndex.dayjs(values?.replaceEndDate).format("YYYY-MM-DD")
    );

    PagesIndex.apiPostHandler(
      PagesIndex.Api.REPLACE_DISCONTINUE_CAPTION,
      urlEncoded
    )
      .then((res) => {
        setButtonSpinner(false);
        if (res.status === 201 || res.status === 200) {
          handleClose();
          setPreviousBookingData([]);
          setCreativesData([]);
          setSubBookingData([]);
          setCreativesByClientData([]);
          formRef.current.resetForm();
          PagesIndex.toasterSuccess(res?.message);
        } else {
          PagesIndex.toasterError(res?.message);
        }
      })
      .catch((err) => {
        PagesIndex.toasterError(err.response.message);
      });
  };
  return (
    <Index.Box className="admin-dashboard-content admin-user-management-content">
      <Index.Box className="admin-user-list-flex admin-page-title-main">
        <Index.Typography
          className="admin-page-title admin-user-list-page-title"
          component="h2"
          variant="h2"
        >
          Replace & Discontinue Caption
        </Index.Typography>
      </Index.Box>
      <PagesIndex.Formik
        enableReinitialize
        onSubmit={handleOpen}
        initialValues={initialValues}
        validationSchema={PagesIndex.replaceSchema}
        innerRef={formRef}
      >
        {({
          values,
          errors,
          touched,
          handleSubmit,
          setFieldValue,
          setFieldTouched,
        }) => (
          <form onSubmit={handleSubmit} noValidate="novalidate">
            <Index.Box className="common-card advertisement-card">
              <Index.Box className="grid-row">
                <Index.Box className="grid-main">
                  <Index.Box
                    gridColumn={{
                      xs: "span 12",
                      sm: "span 12",
                      md: "span 12",
                      lg: "span 12",
                    }}
                    className="grid-column"
                  >
                    <Index.Box className="admin-input-box admin-add-news-input-box">
                      <Index.Box
                        className="admin-news-check-main-replace"
                        id="checked"
                      >
                        <Index.Box className="admin-checkbox-main">
                          <BpCheckbox
                            checked={values?.replace}
                            onChange={() => {
                              const newValue = !values.replace;
                              setFieldValue("replace", newValue);
                              setFieldValue("discontinue", values.replace);
                              setFieldValue("booking", "");
                            }}
                            name="replace"
                          />
                          <Index.Typography className="admin-checkbox-lable">
                            Replace Caption
                          </Index.Typography>
                        </Index.Box>
                        <Index.Box className="admin-checkbox-main">
                          <BpCheckbox
                            checked={values?.discontinue}
                            onChange={() => {
                              const newValue = !values.discontinue;
                              setFieldValue("discontinue", newValue);
                              setFieldValue("replace", values.discontinue);
                            }}
                            name="discontinue"
                          />
                          <Index.Typography className="admin-checkbox-lable">
                            Discontinue Caption
                          </Index.Typography>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>

                  <Index.Box
                    display="grid"
                    gridTemplateColumns="repeat(12, 1fr)"
                    gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                  >
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 3",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="admin-input-box admin-add-event-input-box">
                        <Index.FormHelperText className="admin-form-lable">
                          Client<span className="astrick-sing">*</span>
                        </Index.FormHelperText>
                        <Index.Box className="admin-form-group">
                          <Index.Autocomplete
                            className="admin-auto-complete-control"
                            options={advertisorData || []}
                            id="client"
                            closeText={""}
                            openText={""}
                            clearText={""}
                            value={
                              values?.client
                                ? advertisorData?.find(
                                    (o) => o?._id === values?.client
                                  ) ?? null
                                : null
                            }
                            onChange={(e, value) => {
                              setFieldValue("client", value?._id);
                              setFieldValue("campaign", "");
                              setFieldValue("booking", "");
                              setFieldValue("creative", "");
                              setFieldValue("replaceCampaign", "");
                              setPreviousBookingData([]);
                              if (value?._id) {
                                handleGetCreativesByClient(value?._id);
                              } else {
                                setCreativesByClientData([]);
                              }
                            }}
                            getOptionLabel={(option) => `${option?.compName}`}
                            renderOption={(props, item) => (
                              <li {...props} key={item?._id}>
                                {item?.compName}
                              </li>
                            )}
                            renderInput={(params) => (
                              <Index.TextField
                                fullWidth
                                className="admin-form-control"
                                name="client"
                                {...params}
                                size="small"
                                variant="outlined"
                                placeholder="Select Client"
                              />
                            )}
                          />
                          {touched.client && errors.client && (
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.client}
                            </PagesIndex.FormHelperText>
                          )}
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 3",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="admin-input-box admin-add-event-input-box">
                        <Index.FormHelperText className="admin-form-lable">
                          Campaign <span className="astrick-sing">*</span>
                        </Index.FormHelperText>
                        <Index.Box className="admin-form-group">
                          <Index.Autocomplete
                            className="admin-auto-complete-control"
                            options={
                              salesOrderData?.filter(
                                (data) => data?.client === values?.client
                              ) || []
                            }
                            id="campaign"
                            closeText={""}
                            openText={""}
                            clearText={""}
                            value={
                              values?.campaign
                                ? salesOrderData?.find(
                                    (o) => o?._id === values?.campaign
                                  ) ?? null
                                : null
                            }
                            onChange={(e, value) => {
                              setFieldValue("campaign", value?._id);
                              setFieldValue("booking", "");
                              setFieldValue("creative", "");
                              if (value?._id) {
                                handleGetPreviousBookings(value?._id);
                              } else {
                                setPreviousBookingData([]);
                              }
                            }}
                            getOptionLabel={(option) =>
                              `${option?.orderNo}-${option?.campaignName}`
                            }
                            renderOption={(props, item) => (
                              <li {...props} key={item?._id}>
                                {item?.orderNo}-{item?.campaignName}
                              </li>
                            )}
                            renderInput={(params) => (
                              <Index.TextField
                                fullWidth
                                className="admin-form-control"
                                name="campaign"
                                {...params}
                                size="small"
                                variant="outlined"
                                placeholder="Select Campaign"
                              />
                            )}
                          />
                          {touched.campaign && errors.campaign && (
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.campaign}
                            </PagesIndex.FormHelperText>
                          )}
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                    {console.log(values, "468")}
                    <Index.Box
                      gridColumn={{
                        xs: "span 12",
                        sm: "span 3",
                        md: "span 3",
                        lg: "span 3",
                      }}
                      className="grid-column"
                    >
                      <Index.Box className="admin-input-box admin-add-event-input-box">
                        <Index.FormHelperText className="admin-form-lable">
                          Booking<span className="astrick-sing">*</span>
                        </Index.FormHelperText>
                        <Index.Box className="admin-form-group">
                          <Index.Autocomplete
                            className="admin-auto-complete-control"
                            // options={previousBookingData || []}
                            options={[
                              ...(values?.discontinue
                                ? [
                                    {
                                      _id: "all",
                                      subOrderNo: "All",
                                      name: "Bookings",
                                    },
                                  ]
                                : []),
                              ...(previousBookingData || []),
                            ]}
                            id="booking"
                            closeText={""}
                            openText={""}
                            clearText={""}
                            // value={
                            //   values?.booking
                            //     ? previousBookingData?.find(
                            //         (o) => o?._id === values?.booking
                            //       ) ?? null
                            //     : null
                            // }
                            value={(() => {
                              const data = values.discontinue
                                ? [
                                    {
                                      _id: "all",
                                      subOrderNo: "All",
                                      name: "Bookings",
                                    },
                                    ...(previousBookingData || []),
                                  ]
                                : previousBookingData || [];

                              return (
                                data.find((o) => o?._id === values?.booking) ??
                                null
                              );
                            })()}
                            // onChange={(e, value) => {
                            //   setFieldValue("booking", value?._id);
                            //   setFieldValue("endDate", value?.endDate);

                            //   if (value?._id) {
                            //     handleGetSubBooking(value?._id);
                            //     handleGetCreatives({
                            //       type: values?.discontinue
                            //         ? "discontinue"
                            //         : "replace",
                            //       id: value?._id,
                            //       booking_id: "",
                            //     });
                            //   } else {
                            //     setSubBookingData([]);
                            //     setCreativesData([]);
                            //   }
                            // }}
                            onChange={(e, value) => {
                              if (value?._id === "all") {
                                setFieldValue("booking", "all");
                                const maxEndDate = previousBookingData.reduce(
                                  (latest, curr) => {
                                    const currDate = new Date(curr.endDate);
                                    return currDate > latest
                                      ? currDate
                                      : latest;
                                  },
                                  new Date(0)
                                );
                                setFieldValue("endDate", maxEndDate);
                                setFieldValue("subBooking", "");
                                setFieldValue("creative", "");
                                setSubBookingData([]);
                                setCreativesData([]);
                              } else if (value?._id) {
                                setFieldValue("booking", value._id);
                                setFieldValue("endDate", value?.endDate);
                                handleGetSubBooking(value._id);
                                handleGetCreatives({
                                  type: values?.discontinue
                                    ? "discontinue"
                                    : "replace",
                                  id: value._id,
                                  booking_id: "",
                                });
                                setFieldValue("subBooking", "");
                                setFieldValue("creative", "");
                                setSubBookingData([]);
                                setCreativesData([]);
                                if (values?.discontinue) {
                                  setBookingId(value?._id);
                                }
                              } else {
                                setFieldValue("booking", "");
                                setSubBookingData([]);
                                setCreativesData([]);
                              }
                            }}
                            getOptionLabel={(option) =>
                              `${option?.subOrderNo}-${option?.name}`
                            }
                            renderOption={(props, item) => (
                              <li {...props} key={item?._id}>
                                {item?.subOrderNo}-{item?.name}
                              </li>
                            )}
                            renderInput={(params) => (
                              <Index.TextField
                                fullWidth
                                className="admin-form-control"
                                name="booking"
                                {...params}
                                size="small"
                                variant="outlined"
                                placeholder="Select Booking"
                              />
                            )}
                          />
                          {touched.booking && errors.booking && (
                            <PagesIndex.FormHelperText className="admin-error-text">
                              {errors.booking}
                            </PagesIndex.FormHelperText>
                          )}
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>

                    {values?.booking !== "all" && (
                      <>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 3",
                            md: "span 3",
                            lg: "span 3",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-add-event-input-box">
                            <Index.FormHelperText className="admin-form-lable">
                              Sub Booking
                              {values?.replace && (
                                <span className="astrick-sing">*</span>
                              )}
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.Autocomplete
                                className="admin-auto-complete-control"
                                options={subBookingData || []}
                                id="booking"
                                closeText={""}
                                openText={""}
                                clearText={""}
                                value={
                                  values?.subBooking
                                    ? subBookingData?.find(
                                        (o) => o === values?.subBooking
                                      ) ?? null
                                    : null
                                }
                                onChange={(e, value) => {
                                  setFieldValue("subBooking", value);
                                  setFieldValue("creative", "");
                                  if (value) {
                                    handleGetCreatives({
                                      type: values?.discontinue
                                        ? "discontinue"
                                        : "replace",
                                      id: values?.booking,
                                      booking_id: value,
                                    });
                                  } else {
                                    setCreativesData([]);
                                  }
                                }}
                                getOptionLabel={(option) => option}
                                renderOption={(props, item) => (
                                  <li {...props} key={item}>
                                    {item}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    className="admin-form-control"
                                    name="subBooking"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    placeholder="Select Sub Booking"
                                  />
                                )}
                              />
                              {touched.subBooking && errors.subBooking && (
                                <PagesIndex.FormHelperText className="admin-error-text">
                                  {errors.subBooking}
                                </PagesIndex.FormHelperText>
                              )}
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>

                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 3",
                            md: "span 3",
                            lg: "span 3",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-add-event-input-box">
                            <Index.FormHelperText className="admin-form-lable">
                              Creative
                              {values?.replace && (
                                <span className="astrick-sing">*</span>
                              )}
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.Autocomplete
                                className="admin-auto-complete-control"
                                options={creativesData || []}
                                id="creative"
                                closeText={""}
                                openText={""}
                                clearText={""}
                                value={
                                  values?.creative
                                    ? creativesData?.find(
                                        (o) => o?._id === values?.creative
                                      ) ?? null
                                    : null
                                }
                                onChange={(e, value) => {
                                  setFieldValue("creative", value?._id);
                                }}
                                getOptionLabel={(option) =>
                                  option?.duration
                                    ? `${option?.code}-${option?.name}-${option?.duration} Sec`
                                    : `${option?.code}-${option?.name}`
                                }
                                renderOption={(props, item) => (
                                  <li {...props} key={item?._id}>
                                    {item?.duration
                                      ? `${item?.code}-${item?.name}-${item?.duration} Sec`
                                      : `${item?.code}-${item?.name}`}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    className="admin-form-control"
                                    name="creative"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    placeholder="Select Creative"
                                  />
                                )}
                              />
                              {touched.creative && errors.creative && (
                                <PagesIndex.FormHelperText className="admin-error-text">
                                  {errors.creative}
                                </PagesIndex.FormHelperText>
                              )}
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      </>
                    )}
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>

            {values?.booking !== "all" && (
              <Index.Box className="common-card advertisement-card">
                <Index.Box className="grid-row">
                  <Index.Box className="grid-main">
                    <Index.Box className="admin-sub-title-main">
                      <Index.Typography
                        className="admin-sub-title"
                        component="h2"
                        variant="h2"
                      >
                        {values?.discontinue ? "Discontinue Caption" : ""}
                        {values?.replace ? "Replace Caption" : ""}
                      </Index.Typography>
                    </Index.Box>
                    <Index.Box
                      display="grid"
                      gridTemplateColumns="repeat(12, 1fr)"
                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                    >
                      {values?.replace && (
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 3",
                            md: "span 3",
                            lg: "span 3",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="admin-input-box admin-add-event-input-box">
                            <Index.FormHelperText className="admin-form-lable">
                              Creative<span className="astrick-sing">*</span>
                            </Index.FormHelperText>
                            <Index.Box className="admin-form-group">
                              <Index.Autocomplete
                                className="admin-auto-complete-control"
                                options={creativesByClientData || []}
                                id="replaceCampaign"
                                closeText={""}
                                openText={""}
                                clearText={""}
                                value={
                                  values?.replaceCampaign
                                    ? creativesByClientData?.find(
                                        (o) =>
                                          o?._id === values?.replaceCampaign
                                      ) ?? null
                                    : null
                                }
                                onChange={(e, value) => {
                                  setFieldValue("replaceCampaign", value?._id);
                                }}
                                getOptionLabel={(option) =>
                                  option?.duration
                                    ? `${option?.code}-${option?.name}-${option?.duration} Sec`
                                    : `${option?.code}-${option?.name}`
                                }
                                renderOption={(props, item) => (
                                  <li {...props} key={item?._id}>
                                    {item?.duration
                                      ? `${item?.code}-${item?.name}-${item?.duration} Sec`
                                      : `${item?.code}-${item?.name}`}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <Index.TextField
                                    fullWidth
                                    className="admin-form-control"
                                    name="replaceCampaign"
                                    {...params}
                                    size="small"
                                    variant="outlined"
                                    placeholder="Select Creative"
                                  />
                                )}
                              />
                              {touched.replaceCampaign &&
                                errors.replaceCampaign && (
                                  <PagesIndex.FormHelperText className="admin-error-text">
                                    {errors.replaceCampaign}
                                  </PagesIndex.FormHelperText>
                                )}
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                      )}
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 3",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="admin-input-box admin-date-input-main ">
                          <Index.FormHelperText className="admin-form-lable">
                            <span>Start Date</span>
                            <span className="astrick-sing">*</span>
                          </Index.FormHelperText>
                          <Index.Box className="admin-form-group">
                            <PagesIndex.LocalizationProvider
                              dateAdapter={Index.AdapterDayjs}
                            >
                              <PagesIndex.DatePicker
                                open={openCalenderReplaceStart}
                                onClose={() =>
                                  setOpenCalenderReplaceStart(false)
                                }
                                className="admin-form-control admin-date-picker-control"
                                value={values.replaceStartDate} // Use '01/01/2000' as the default value
                                onChange={(date) => {
                                  setFieldValue("replaceStartDate", date);
                                  setFieldTouched("replaceStartDate", false);
                                  setFieldValue("replaceEndDate", null);
                                }}
                                minDate={PagesIndex.dayjs()}
                                maxDate={PagesIndex.dayjs(values?.endDate)}
                                slotProps={{
                                  popper: {
                                    className: "date-picker-body",
                                  },
                                  textField: {
                                    readOnly: true,
                                    onClick: () =>
                                      setOpenCalenderReplaceStart(true),
                                  },
                                  inputAdornment: {
                                    onClick: () =>
                                      setOpenCalenderReplaceStart(true), // This triggers on the calendar icon
                                  },
                                }}
                                format="DD/MM/YYYY"
                              />
                            </PagesIndex.LocalizationProvider>
                            <Index.FormHelperText className="admin-error-text">
                              {errors.replaceStartDate &&
                                touched.replaceStartDate &&
                                errors.replaceStartDate}
                            </Index.FormHelperText>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 3",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="admin-input-box admin-date-input-main ">
                          <Index.FormHelperText className="admin-form-lable">
                            <span>End Date</span>
                            <span className="astrick-sing">*</span>
                          </Index.FormHelperText>
                          <Index.Box className="admin-form-group">
                            <PagesIndex.LocalizationProvider
                              dateAdapter={Index.AdapterDayjs}
                            >
                              <PagesIndex.DatePicker
                                open={openCalenderReplaceEnd}
                                onClose={() => setOpenCalenderReplaceEnd(false)}
                                className="admin-form-control admin-date-picker-control"
                                value={values.replaceEndDate} // Use '01/01/2000' as the default value
                                onChange={(date) => {
                                  setFieldValue("replaceEndDate", date);
                                  setFieldTouched("replaceEndDate", false);
                                }}
                                minDate={
                                  values.replaceStartDate
                                    ? PagesIndex.dayjs(values.replaceStartDate)
                                    : PagesIndex.dayjs()
                                }
                                maxDate={PagesIndex.dayjs(values?.endDate)}
                                slotProps={{
                                  popper: {
                                    className: "date-picker-body",
                                  },
                                  textField: {
                                    readOnly: true,
                                    onClick: () =>
                                      setOpenCalenderReplaceEnd(true),
                                  },
                                  inputAdornment: {
                                    onClick: () =>
                                      setOpenCalenderReplaceEnd(true), // This triggers on the calendar icon
                                  },
                                }}
                                format="DD/MM/YYYY"
                              />
                            </PagesIndex.LocalizationProvider>
                            <Index.FormHelperText className="admin-error-text">
                              {errors.replaceEndDate &&
                                touched.replaceEndDate &&
                                errors.replaceEndDate}
                            </Index.FormHelperText>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            )}
            {adminDetails?.roleId?.permissions?.includes(
              "replace_discontinue_caption_replace"
            ) && (
              <Index.Box className="admin-user-btn-flex">
                <Index.Box className="border-btn-main"></Index.Box>
                <Index.Box className="btn-main-primary">
                  <Index.Button
                    className={`btn-primary`}
                    type="submit"
                    disabled={buttonSpinner}
                  >
                    {buttonSpinner ? (
                      <PagesIndex.Spinner />
                    ) : (
                      <>
                        <img
                          src={PagesIndex.Svg.save}
                          className="admin-user-save-icon"
                          alt="Save"
                        />
                        <span>
                          {values?.discontinue ? "Discontinue" : ""}
                          {values?.replace ? "Replace" : ""}{" "}
                        </span>
                      </>
                    )}
                  </Index.Button>
                </Index.Box>
              </Index.Box>
            )}
            <Index.Modal
              open={open}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="admin-modal"
            >
              <Index.Box
                sx={style}
                className="admin-delete-modal-inner-main admin-modal-inner"
              >
                <Index.Box className="admin-modal-hgt-scroll cus-scrollbar">
                  <Index.Typography
                    className="admin-delete-modal-title"
                    component="h2"
                    variant="h2"
                  >
                    Are you sure?
                  </Index.Typography>
                  <Index.Typography
                    className="admin-delete-modal-para admin-common-para"
                    component="p"
                    variant="p"
                  >
                    Do you really want to{" "}
                    {formRef?.current?.values?.replace && "replace"}
                    {formRef?.current?.values?.discontinue &&
                      "discontinue"}{" "}
                    this creative?
                  </Index.Typography>
                  <Index.Box className="admin-delete-modal-btn-flex border-btn-main btn-main">
                    <Index.Button
                      className="admin-modal-cancel-btn border-btn"
                      onClick={handleClose}
                      disabled={buttonSpinner}
                    >
                      Cancel
                    </Index.Button>
                    <Index.Button
                      className="delete-user admin-modal-delete-btn btn"
                      onClick={() => handleSubmitForm(values)}
                      disabled={buttonSpinner}
                    >
                      {buttonSpinner ? (
                        <PagesIndex.Spinner />
                      ) : (
                        <span>Confirm</span>
                      )}
                    </Index.Button>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Modal>
          </form>
        )}
      </PagesIndex.Formik>
    </Index.Box>
  );
}
